import { render, staticRenderFns } from "./KodeRegisterBarang.vue?vue&type=template&id=18617879&"
import script from "./KodeRegisterBarang.vue?vue&type=script&lang=js&"
export * from "./KodeRegisterBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports